import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../../actions';
import PropTypes from 'prop-types';
import { StyledTitle } from './custom-styled-components/_MyCustomSC';
import  "../../CSS/Grid.css"
import { Select, Form, Tooltip } from 'antd';
import { isEmpty } from '../../util/isEmpty';
import ExistingFactoryDropdown from './ExistingFactoryDropdown';
import {value} from "lodash/seq";
import {Update_Factory_select} from "../../actions";
import { getPostalCode, fetchPostalCode } from '../../util/getPostalCode';
import RowTable from '../result-section/finalResultCard/RowTable';
// import {getFactory} from "../../actions";
const { Option } = Select;

const EXISTING_FACTORY = 'existing factory';
const NEW_FACTORY = 'new factory';

const SHOW_RULES = true; //for showing validation error in production, make it 'true'

const pickupNewFactoryNames = [
  'Existing Business/Factory',
  'New Business/Factory',
];

const deliveryNewFactoryNames = [
  'Existing Business/Location',
  'New Business/Location',
];

/**
 * @component
 * @category Form Page
 * @name PickupDeliveryFactorySet
 * @description not documented yet
 * <br> <br>
 * **Example**
 * ```js
 *
 *<PickupDeliveryFactory isPickupFactory={true} mode={'pickup'} onFactoryDataChange={()=>{}} />
 * ```
 */
class PickupDeliveryFactorySet extends Component {
  state = {
    selectedId: null,
    postal: "",
    loadingPostalCode : false
  };

  /**
   * @description when an "existing factory" or "new factory" is selected from the dropdown
   * <br> <br>
   * **onSelectChange(value) -> {void}**
   * <br><br>
   * **Parameters:**
   * | Name          | Type          | Description  |
   * | :------------ |:------------- | :------------|
   * | value         | string        | either `existing factory` or `new factory` |

   * Returns: Type: void
   */
  onSelectChange = (value) => {
    if (value === EXISTING_FACTORY) {
      this.props.onFactoryDataChange(true, this.state.selectedId); // send to parent compo
    } else {
      //new factory
      this.props.onFactoryDataChange(false, null); // send to parent compo
      this.setState({
        selectedId: null,
      });
    }

    //newly added
    if (this.props.isPickupFactory) {
      this.props.updatePickupData({
        selectedExistingFactoryJson: '',
      });
    } else {
      this.props.updateDeliveryData({
        selectedExistingFactoryJson: '',
      });
    }

    //check for pickup/delivery type
    if (this.props.isPickupFactory) {
      this.props.getExistingFactoryPickupData();
    } else {
      this.props.getExistingFactoryDeliveryData();
    }
  };

  /**
   * @description when an existing factory is selected in the dropdown
   * <br> <br>
   * **onExistingFactorySelectChange(id) -> {void}**
   * <br><br>
   * **Parameters:**
   * | Name          | Type          | Description  |
   * | :------------ |:------------- | :------------|
   * | id            | number        | selected existing factory array index e.g. `0`, `1` |

   * Returns: Type: void
   */
  onExistingFactorySelectChange = async (id,event) => {
    let selected_company={
      "id":id,
      "name":event.key
    }

    const {
      isPickupFactory,
      pickupExistingFactoryJson,
      deliveryExistingFactoryJson,
      transaction_type
    } = this.props;

    //
    const existingFactoryJson = isPickupFactory
        ? pickupExistingFactoryJson
        : deliveryExistingFactoryJson;



    const selectedFactoryJson = existingFactoryJson.filter((value,index)=>{
      if(value.id===selected_company.id){
        return value
      }
    })


    if(selected_company.id==="new"){
      // console.log(selectedFactoryJson)
      this.props.Update_Factory_select({},isPickupFactory)
      this.props.NewFactoryMode()
    }else{
      this.props.Update_Factory_select(selectedFactoryJson[0],isPickupFactory)
      this.props.onFactoryDataChange(isPickupFactory,selectedFactoryJson[0])
      this.props.setLCLSliderChange(false);
    }
  };

  /**
   * @description it validates pickup/delivery dropdowns, it shows error if the dropdowns are not selected
   * <br> <br>
   * **showSelectValidation(showFormValidation) -> {void}**
   * <br><br>
   * **Parameters:**
   * | Name          | Type          | Description  |
   * | :------------ |:------------- | :------------|
   * | showFormValidation      | boolean        | whether to show validation in pickup, delivery form dropdown. |

   * Returns: Type: void
   */
  showSelectValidation = (showFormValidation) => {
    showFormValidation && this.props.form.validateFields();
  };

  componentDidUpdate = (prevProps, prevState, snapshot) => {
    const { showFormValidation } = this.props;

    if (showFormValidation !== prevProps.showFormValidation) {
      this.showSelectValidation(showFormValidation);
    }
  };

  componentDidMount = () => {
    // this.props.getFactory()
    const { showFormValidation, isPickupFactory ,selectedPickupExistingFactoryJson,selectedDeliveryExistingFactoryJson} = this.props;
    this.showSelectValidation(showFormValidation);
    //for setting old datas to pickup/delivery data if user clicked back/edit search btn
    const { pickupFactoryInfo, deliveryFactoryInfo } = this.props;

    const isExistingFactorySelected = isPickupFactory
      ? selectedPickupExistingFactoryJson.isExistingFactorySelected
      : selectedDeliveryExistingFactoryJson.isExistingFactorySelected;

    // if (showFormValidation) {
    //   //set select factory type
    //   //Select factory type
    //   const selectFactoryTypeValue =
    //     isExistingFactorySelected !== null
    //       ? isExistingFactorySelected
    //         ? EXISTING_FACTORY
    //         : NEW_FACTORY
    //       : undefined;
    //   this.props.form.setFieldsValue({
    //     'select-factory': selectFactoryTypeValue,
    //   });
    // }
  };

  render() {

    const {
      isPickupFactory,
      pickupFactoryInfo,
      deliveryFactoryInfo,
      mode,
      pickupExistingFactoryJson,
      deliveryExistingFactoryJson,
      transaction_type
    } = this.props;

    const existingFactoryJson = isPickupFactory
      ? pickupExistingFactoryJson
      : deliveryExistingFactoryJson;


    // const { getFieldDecorator } = this.props.form;


    //for selecting init existing factory
    const {
      selectedPickupExistingFactoryJson,
      selectedDeliveryExistingFactoryJson,
      changeDrop,
      final_view_after_submit
    } = this.props;

    let showInitExistingFactorySelect = false;

    const selectedExistingFactoryJson = isPickupFactory
      ? selectedPickupExistingFactoryJson
      : selectedDeliveryExistingFactoryJson;

    if (selectedExistingFactoryJson && !isEmpty(selectedExistingFactoryJson)) {
      showInitExistingFactorySelect = true;
    }

    return (
      <div>
        <span
          style={{
            width: '100%',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'start',
            alignItems: 'flex-start',
          }}
        >
          {/*<span  style={{ width: '100%' }}></span>*/}
            <Form style={{ width: '100%',
              display: "flex",
              textAlign: "center",
              justifyContent: "center",
              alignItems: "center",
            }}>
                        <div className="parent parentContent">
                          {!final_view_after_submit &&(
                              <div className="child textCenter">
                                {
                                  this.props.transaction_type === 'Importer' ?   
                                  isPickupFactory ? "Select Shipper" :  "Select Delivery Location" 
                                  :
                                  isPickupFactory ? "Select Pickup Location" :  "Select Receiver"
                                }
                              </div>
                          )}
                          <div className="child">
                              <ExistingFactoryDropdown
                                  data={existingFactoryJson}
                                  isPickupFactory={isPickupFactory}
                                  changeDrop={changeDrop}
                                  onExistingFactorySelectChange={
                                    this.onExistingFactorySelectChange
                                  }
                                  loadingPostalCode = {this.state.loadingPostalCode}
                              />
                          </div>
                        </div>

            </Form>
        </span>
      </div>
    );
  }
}

// PickupDeliveryFactorySet.defaultProps = {
//   isPickupFactory: true,
// };

PickupDeliveryFactorySet.propTypes = {
  /**
   * pickup existing factory json
   */
  pickupExistingFactoryJson: PropTypes.object,
  /**
   *  delivery existing factory json
   */
  deliveryExistingFactoryJson: PropTypes.object,
  /**
   *whether to show validation in pickup, delivery form dropdown.
   */
  showFormValidation: PropTypes.bool,
  /**
   * delivery factory info
   */
  deliveryFactoryInfo: PropTypes.object,
  /**
   * pickup factory info
   */
  pickupFactoryInfo: PropTypes.object,
  /**
   * selected Existing Factory for pickup on factory mode
   */
  selectedPickupExistingFactoryJson: PropTypes.object,
  /**
   * selected Existing Factory for delivery on factory mode
   */
  selectedDeliveryExistingFactoryJson: PropTypes.object,
  /**
   * whether it's used in pickup or delivery section
   */
  mode: PropTypes.string,
  /**
   * whether it iss used in pickup section
   */
  isPickupFactory: PropTypes.bool,
  /**
   * it invokes when existing factory or "new factory" is selected
   */
  onFactoryDataChange: PropTypes.func,
};

const mapStateToProps = (state) => {
  const { pickup, delivery } = state.form;
  const { transactionType } = state.code_config;

  // Swap values based on transaction_type
  const pickupExistingFactoryJson = transactionType === 'Exporter'
    ? delivery.existingFactoryJson
    : pickup.existingFactoryJson;

  const deliveryExistingFactoryJson = transactionType === 'Exporter'
    ? pickup.existingFactoryJson
    : delivery.existingFactoryJson;
  return {
    pickupExistingFactoryJson,
    deliveryExistingFactoryJson,
    showFormValidation: state.form.showFormValidation,
    know_users_details:state.route.User_factor_and_shipper_Details,
    deliveryFactoryInfo: state.form.factoryInfo.delivery,
    pickupFactoryInfo: state.form.factoryInfo.pickup,
    // :state.form.Update_Factory_select,
    selectedPickupExistingFactoryJson:
      state.form.pickup.selectedExistingFactoryJson,
    selectedDeliveryExistingFactoryJson:
      state.form.delivery.selectedExistingFactoryJson,
    final_view_after_submit:state.form.final_view_after_submit,
    transaction_type: state.code_config.transactionType,
    queryParams: state.route.queryParams,
  };
};

const PickupDeliveryFactory = Form.create({
  name: 'pickup-delivery-factory-set',
})(PickupDeliveryFactorySet);

export default connect(mapStateToProps, actions)(PickupDeliveryFactory);
